"use strict" ;

import display from './process/display'

/**
 * The {@link molecule.render.dom.process} package.
 * @summary The {@link molecule.render.dom.process} package.
 * @license {@link https://www.mozilla.org/en-US/MPL/2.0/)|MPL 2.0} / {@link https://www.gnu.org/licenses/old-licenses/gpl-2.0.fr.html|GPL 2.0} / {@link https://www.gnu.org/licenses/old-licenses/lgpl-2.1.fr.html|LGPL 2.1}
 * @author Marc Alcaraz <ekameleon@gmail.com>
 * @namespace molecule.render.dom.process
 * @memberof molecule.render.dom
 * @version 1.0.19
 * @since 1.0.8
 */
const process = Object.assign
({
    display : display
});

export default process ;